import { Button } from './ui/button';
import { useSidebar } from './ui/sidebar';
import { MenuIcon, PanelRightClose } from 'lucide-react';

export const SyfoSidebarTrigger = () => {
  const { toggleSidebar, open } = useSidebar();
  
  return (
    <Button
      variant="outline"
      size="icon"
      onClick={toggleSidebar}
      className="relative cursor-pointer"
    >
      {open ? (
        <PanelRightClose className="h-[1.2rem] w-[1.2rem]" />
      ) : (
        <MenuIcon className="h-[1.2rem] w-[1.2rem]" />
      )}
      <span className="sr-only">{open ? 'Close Sidebar' : 'Open Sidebar'}</span>
    </Button>
  );
};